import { useSearchEngineStore } from '../../../stores/searchStore'
import {
  MdOutlineBusiness,
  MdOutlineHome,
  MdOutlineLandscape,
  MdOutlineMapsHomeWork
} from 'react-icons/md'

import { ButtonLikeCheckbox } from './ButtonLikeCheckbox'
import { PropertyTypes } from '@monopolio-ui/types-library'

interface Props {
  isActiveButtonClassName?: string
}

export const PropertyType = ({ isActiveButtonClassName }: Props) => {
  const { propertyTypes, setPropertyTypes } = useSearchEngineStore((state) => state)
  
  const propertyTypeOptions: {
    title: string
    icon: React.ReactNode
    code: PropertyTypes
  }[] = [
    {
      title: 'Casa',
      code: PropertyTypes.HOUSE,
      icon: <MdOutlineHome className="w-4 h-4" />
    },
    {
      title: 'Depto',
      code: PropertyTypes.APARTMENT,
      icon: <MdOutlineBusiness className="w-4 h-4" />
    },
    {
      title: 'Terreno',
      code: PropertyTypes.TERRAIN,
      icon: <MdOutlineLandscape className="w-4 h-4" />
    },
    {
      title: 'Otro',
      code: PropertyTypes.OTHER,
      icon: <MdOutlineMapsHomeWork className="w-4 h-4" />
    }
  ]

  const handleOnClick = (code: string) => {
    const find = propertyTypes.find((opt) => opt === code)
    const updated = [...propertyTypes]

    if (find) {
      const index = updated.indexOf(find)
      updated.splice(index, 1)
    } else {
      updated.push(code)
    }

    setPropertyTypes(updated)
  }

  return (
    <div className="flex flex-col gap-y-3">
      <span className="text-normal font-semibold text-[#222]">
        ¿Qué tipo de propiedad buscas?
      </span>
      <div className="flex items-center md:gap-3 gap-1">
        {propertyTypeOptions.map(({ code, title, icon}) =>  (
          <ButtonLikeCheckbox
            code={code}
            title={title}
            icon={icon}
            isSelected={propertyTypes?.includes(code)}
            onClick={(code: string) => handleOnClick(code)}
            textClassName={"w-full text-center"}
            isActiveButtonClassName={isActiveButtonClassName}
          />
        ))}
      </div>
    </div>
  )
}

